/* tslint:disable:react-a11y-anchors */
import * as React from 'react'

import AudioPlayerSmallContainer from '../audio/audioPlayerSmallContainer'
import TrendingSash from './common/trendingSash'

import * as styles from './gridAudio.module.css'

const AudioPreview = ({
  imageUrl,
  audioUrl,
  url,
  isTrending,
  name,
  onClick,
  rank
}: {
  imageUrl: string | undefined
  audioUrl: string
  url: string
  isTrending: boolean
  name: string
  onClick?: () => void
  rank: number
}) => {
  return (
    <div>
      <div className={styles.miniAudioPlayerContainer}>
        <AudioPlayerSmallContainer src={audioUrl} />
      </div>
      <a
        className={styles.thumbnail}
        href={`${url}?s_rank=${rank}`}
        onClick={onClick}
      >
        {isTrending && <TrendingSash />}
        <img alt={name} src={imageUrl} title={name} width="80" height="80" />
      </a>
    </div>
  )
}

export default AudioPreview
